import { Transition } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid"
import { useEffect, useState } from "react"
import { NotificationBarConfig } from "../context/notificationContext"
import { LoaderIcon } from "./icons/LoaderIcon"
import { Loader } from "./loader"

const DEFAULT_TIMEOUT = 5000

interface ComponentProps {
    config: NotificationBarConfig
    onClose: (config: NotificationBarConfig) => void
}
export const NotificationBarComponent: React.FC<ComponentProps> = ({ config: inputConfig, onClose }) => {
    const [isShowing, setIsShowing] = useState(false)
    const [config, setConfig] = useState<NotificationBarConfig>(inputConfig)

    useEffect(() => {
      setConfig(inputConfig)
    }, [inputConfig])
    
    useEffect(() => {
        let timeoutIns;
        
        if(config?.timeout !== 'infinite') {
            timeoutIns = setTimeout(() => {
                setIsShowing(false)
                onClose(config)
            }, config?.timeout ?? DEFAULT_TIMEOUT);
        }
        if (config._isHidden) {
            setIsShowing(false)
        }
        else {
            setIsShowing(true)
        }
        return () => {
            clearTimeout(timeoutIns)
        }
    }, [config])
    return (
        <Transition
            show={isShowing}
            enter="transform transition duration-[400ms]"
            enterFrom="opacity-0 translate-x-96 scale-50"
            enterTo="opacity-100 translate-x-0 scale-100"
            leave="transform duration-200 transition ease-in-out"
            leaveFrom="opacity-100 rotate-0 scale-100 "
            leaveTo="opacity-0 scale-95 "
            as="div"
        >
            <div className={`p-4 max-w-4xl border-t-4 bg-white dark:bg-slate-900 dark:text-white rounded-md z-50 shadow-lg ${config.positionClass} ${(config?.type === 'success' && 'border-t-green-500') || (config?.type === 'error' && 'border-t-red-500') || 'border-blue-500' }`}>
                <div className="flex items-center gap-3">
                    <div>
                        {
                            (config.type === 'error' && <ExclamationTriangleIcon className="h-4 w-4 text-red-600" />) ||
                            (config.type === 'success' && <CheckCircleIcon className="h-4 w-4 text-green-600" />) ||
                            (config.type === 'progress' && <Loader className="h-4 w-4 text-blue-600"/>) ||
                            <ExclamationCircleIcon className="h-4 w-4 text-blue-600" />
                        }
                    </div>
                    <div>
                        <h1 className="text-md font-semibold">{config.title}</h1>
                    </div>
                    <div className="ml-auto">
                        <button className="cursor-pointer" onClick={()=>{
                            setIsShowing(false);
                            onClose(config);
                        }}>
                            <XMarkIcon className={`h-4 w-4 text-black dark:text-white`} />
                        </button>
                    </div>
                </div>
                {config.message && <p className="text-xs mt-2">
                    {config.message}
                </p>}
            </div>
        </Transition>
    )
}